/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Confirm_Regenerate_MsgInputs */



/**
* | output |
* | --- |
* | "This will invalidate the current client secret. All existing integrations using the old secret will stop working." |
*
* @param {Developer_Confirm_Regenerate_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_confirm_regenerate_msg = /** @type {((inputs?: Developer_Confirm_Regenerate_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Confirm_Regenerate_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cela invalidera le secret client actuel. Toutes les intégrations existantes utilisant l'ancien secret cesseront de fonctionner.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esto invalidará el secreto de cliente actual. Todas las integraciones existentes que usen el secreto antiguo dejarán de funcionar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Isso invalidará o client secret atual. Todas as integrações existentes usando o secret antigo pararão de funcionar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo invaliderà il client secret corrente. Tutte le integrazioni esistenti che usano il vecchio secret smetteranno di funzionare.")
	return /** @type {LocalizedString} */ ("This will invalidate the current client secret. All existing integrations using the old secret will stop working.")
});